import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectDatepickerViewConfig} from '../select-dialog.component';
import {divideArrayIntoChunks} from '../../../../utils/number-utils';

@Component({
  selector: 'app-select-datepicker-list',
  templateUrl: './select-datepicker-list.component.html',
  styleUrls: []
})
export class SelectDatepickerListComponent implements OnInit {

  @Input() items;
  @Input() viewConfig: SelectDatepickerViewConfig;
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
  activePageIndex = 0;
  pages: any[][];

  get pageSize(): number {
    return this.viewConfig.rowsNumber * this.viewConfig.columnsNumber;
  }

  get activePageItems(): any[] {
    return this.pages && !!this.pages.length ? this.pages[this.activePageIndex] : [];
  }

  get prevPageDisabled(): boolean {
    return this.activePageIndex === 0;
  }

  get nextPageDisabled(): boolean {
    return this.activePageIndex === this.pages.length - 1;
  }

  constructor() { }

  ngOnInit() {
    this.items = this.items.sort();
    this.paginateItems();
  }

  prev() {
    if (!this.prevPageDisabled) {
      this.activePageIndex = this.activePageIndex - 1;
    }
  }

  next() {
    if (!this.nextPageDisabled) {
      this.activePageIndex = this.activePageIndex + 1;
    }
  }

  select(item: any): void {
    this.itemSelected.emit(item);
  }

  private paginateItems(): void {
    this.pages = divideArrayIntoChunks(this.items, this.pageSize);
  }

}
